import { TimeHelper } from '@/helpers/TimeHelper';

class RoleModel {
  id;
  ownerId;
  createdOn;
  name;
  status;
  description;
  allows;
  organisations;
  farms;
  orchards;

  constructor(data) {
    this.populate(data || {});
  }

  get dateCreated() {
    return TimeHelper.formatDate(this.createdOn);
  }

  populate(data) {
    this.id = data.id || null;
    this.ownerId = data.ownerId || null;
    this.status = data.status || '';
    this.name = data.name || '';
    this.description = data.description || '';
    this.createdOn = data.createdOn || null;
    this.allows = data.allows || [];
    this.organisations = data.organisations || [];
    this.farms = data.farms || [];
    this.orchards = data.orchards || [];
  }

  exportToCreate() {
    return {
      name: this.name,
      description: this.description,
      allows: this.allows
    };
  }
}

export { RoleModel };
